import ResponsiveImage from "../../Element/ResponsiveImage";
import { BaseTeaserData } from "../../Utility/dataTypes";
import style from "./index.module.css";

export type RelatedArticleData = {
  title: string;
  url: string;
  image?: BaseTeaserData["image"];
  sections?: BaseTeaserData["sections"];
  description?: string;
};

type Props = RelatedArticleData & {
  displayImage: boolean;
  imageErrorSrc?: string;
  hasRelatedPrefix?: boolean;
};

const RelatedArticleItem = ({
  url,
  title,
  image,
  displayImage,
  imageErrorSrc,
  hasRelatedPrefix,
}: Props) => {
  const selectedCrop = image?.crops?.landscape || image?.crops?.original;

  const imageContainer = displayImage && selectedCrop && (
    <span className={style.imageContainer}>
      <ResponsiveImage
        {...selectedCrop}
        displayWidth={225}
        errorSrc={imageErrorSrc}
      />
    </span>
  );
  return (
    <a href={url} className={style.itemContainer}>
      {imageContainer}
      <span className={style.textContainer}>
        {hasRelatedPrefix && <b>Related: </b>}
        {title}
      </span>
    </a>
  );
};

export default RelatedArticleItem;
